<template>
  <div class="qpanel">
    <b-row class="divider">
      <b-col> 그룹문항-{{ question.id }} </b-col>
    </b-row>

    <b-row class="below">
      <b-col sm="2" lg="2">개별 지시문</b-col>
      <b-col v-html="question.qstatement"></b-col>
    </b-row>

    <b-row class="below">
      <b-col sm="2" lg="2">문제</b-col>
      <b-col v-html="question.title"></b-col>
    </b-row>

    <template v-if="q_type == '1'">
      <b-row class="below" :key="a.id" v-for="a in answers">
        <b-col sm="2" lg="2">정답{{ a.id }}</b-col>
        <b-col v-html="a.t2"></b-col>
        <b-col sm="3" lg="3">{{ a.t1 }}</b-col>
      </b-row>
    </template>
    <template v-if="q_type == '2'">
      <b-row class="below" :key="a.id" v-for="a in answers">
        <b-col sm="2" lg="2">선택지{{ a.id }}</b-col>
        <b-col sm="3" lg="3" v-html="a.t2"></b-col>
        <b-col v-html="a.t3"></b-col>
      </b-row>
    </template>

    <template v-if="q_type == '3' || q_type == '6'">
      <b-row class="below" :key="a.id" v-for="a in answers">
        <b-col sm="2" lg="2">선택지{{ a.id }}</b-col>
        <b-col sm="3" lg="3" v-html="a.t1"></b-col>
        <b-col sm="3" lg="3">{{ a.t3 }}</b-col>
        <b-col v-html="a.t2"></b-col>
      </b-row>
    </template>

    <template v-if="q_type == '4'">
      <b-row class="below" :key="a.id" v-for="a in answers">
        <b-col sm="2" lg="2">정답</b-col>
        <b-col sm="3" lg="3" v-html="a.t1"></b-col>
      </b-row>
    </template>
    <template v-if="q_type == '5'">
      <b-row class="below tied" :key="a.id" v-for="a in answers">
        <b-col sm="2" lg="2">문항{{ a.id }}</b-col>
        <b-col sm="10" lg="10" v-html="a.t1"></b-col>
      </b-row>
    </template>

    <template v-if="q_type == '7'">
      <b-row class="below tied" :key="a.id" v-for="a in answers">
        <b-col sm="2" lg="2">선택지{{ a.id }}</b-col>
        <b-col sm="3" lg="3" v-html="a.t1"></b-col>
        <b-col sm="3" lg="3">{{ a.t3 }}</b-col>
        <b-col v-html="a.t2"></b-col>
      </b-row>
    </template>

    <template v-if="q_type == '8'">
      <b-row class="below tied" :key="a.id" v-for="a in answers">
        <b-col sm="2" lg="2">정답{{ a.id }}</b-col>
        <b-col sm="3" lg="3" v-html="a.t1"></b-col>
        <b-col sm="3" lg="3" v-html="a.t2"></b-col>
      </b-row>
    </template>

    <b-row class="below" v-if="std_type_code != 3">
      <b-col sm="2" lg="2">출제포인트</b-col>
      <b-col>
        {{ intent }}<br />
        {{ intent2 }}<br />
        {{ intent3 }}
      </b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code == 3">
      <b-col sm="2" lg="2">출제포인트</b-col>
      <b-col v-html="intentForReading"> </b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code == 3">
      <b-col sm="2" lg="2">해설</b-col>
      <b-col v-html="question.qcomment"></b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code == 3">
      <b-col sm="2" lg="2">배점</b-col>
      <b-col v-html="question.point"></b-col>
    </b-row>

    <b-row class="below">
      <b-col sm="2" lg="2">이미지</b-col>
      <b-col>
        {{ question.image }}
      </b-col>
    </b-row>
    <b-row class="below">
      <b-col sm="2" lg="2">음원</b-col>
      <b-col>
        {{ question.sound }}
      </b-col>
    </b-row>

    <PreviewGroupVideos :videos="videos" />

    <b-row class="below">
      <b-col sm="2" lg="2">난이도</b-col>
      <b-col class="lvlwrapper" v-html="level"></b-col>
    </b-row>

    <b-row class="below" v-show="1 == 2">
      <b-col sm="2" lg="2">어휘</b-col>
      <b-col>
        {{ question.word_level }}
      </b-col>
    </b-row>
    <b-row class="below">
      <b-col sm="2" lg="2">기출정보</b-col>
      <b-col>
        {{ question.prevtest_info }}
      </b-col>
    </b-row>
  </div>
</template>

<script>
import * as R from "ramda";
import PreviewGroupVideos from "@/components/preview/PreviewGroupVideos";
export default {
  props: ["question"],
  components: { PreviewGroupVideos },

  computed: {
    std_type_code() {
      return this.$store.state.questionmeta.std_type;
    },

    q_type() {
      return this.question.q_type;
    },
    answers() {
      let q_type = this.question.q_type;
      let q_type_sub = this.question.q_type_sub;

      let answers = [];
      if (q_type == "1") {
        for (let i = 1; i <= 10; i++) {
          console.log(this.question[`ans${i}_text`]);
          if (
            this.question[`ans${i}_text`] != "" &&
            this.question[`ans${i}_text`] != null
          ) {
            let a = {};
            a.id = i;
            a.t1 = this.question[`ans${i}`];
            a.t2 = this.question[`ans${i}_text`];
            answers.push(a);
          }
        }
      } else if (this.q_type == "2") {
        console.log(this.question);
        for (let i = 1; i <= 10; i++) {
          if (
            this.question[`ans${i}_text`] != "" &&
            this.question[`ans${i}_text`] != null
          ) {
            let a = {};
            a.id = i;
            a.t1 = this.question[`ans${i}`];
            a.t2 = this.question[`ans${i}_text`];
            a.t3 = this.question[`ans${i}_sub`] == "1" ? "[정답]" : "";
            answers.push(a);
          }
        }
      } else if (this.q_type == "3") {
        console.log("catch here");
        for (let i = 1; i <= 10; i++) {
          if (
            (this.question[`ans${i}_text`] != "" &&
              this.question[`ans${i}_text`] != null) ||
            (this.question[`ans${i}`] != "" && this.question[`ans${i}`] != null)
          ) {
            let a = {};
            a.id = i;
            a.t1 = this.question[`ans${i}`];
            a.t2 = this.question[`ans${i}_text`];
            a.t3 = this.question[`ans${i}_sub`] == "1" ? "[정답]" : "";
            answers.push(a);
          }
        }
      } else if (this.q_type == "4") {
        let a = {};
        a.id = 1;
        a.t1 = this.question.ans1;

        answers.push(a);
      } else if (this.q_type == "5") {
        for (let i = 1; i <= 10; i++) {
          if (
            this.question[`ans${i}`] != "" &&
            this.question[`ans${i}`] != null
          ) {
            let a = {};
            a.id = i;
            a.t1 = this.question[`ans${i}`];
            answers.push(a);
          }
        }
      } else if (this.q_type == "6") {
        for (let i = 1; i <= 10; i++) {
          if (
            this.question[`ans${i}`] != "" &&
            this.question[`ans${i}`] != null
          ) {
            let a = {};
            a.id = i;
            a.t1 = this.question[`ans${i}`];
            a.t2 = this.question[`ans${i}_text`];
            answers.push(a);
          }
        }
      } else if (this.q_type == "7") {
        for (let i = 1; i <= 10; i++) {
          if (
            this.question[`ans${i}`] != "" &&
            this.question[`ans${i}`] != null
          ) {
            let a = {};
            a.id = i;
            a.t1 = this.question[`ans${i}`];
            a.t2 = this.question[`ans${i}_text`];
            a.t3 = this.question[`ans${i}_sub`] == "1" ? "[정답]" : "";
            answers.push(a);
          }
        }
      } else if (this.q_type == "8") {
        for (let i = 1; i <= 10; i++) {
          if (
            this.question[`ans${i}_text`] != "" &&
            this.question[`ans${i}_text`] != null
          ) {
            let a = {};
            a.id = i;
            a.t1 = this.question[`ans${i}`];
            a.t2 = this.question[`ans${i}_text`];
            a.t3 = this.question[`ans${i}_sub`] == "1" ? "[정답]" : "";
            answers.push(a);
          }
        }
      }

      console.log(answers);
      return answers;
    },
    intent() {
      try {
        let intent = JSON.parse(this.question.intent1);
        return `${intent.d1}->${intent.d2}->${intent.d3}`;
      } catch (e) {
        return "";
      }
    },
    intentForReading() {
      let compound_intent = "";
      try {
        let intent = JSON.parse(this.question.intent1);
        // return `${intent.text}`;
        compound_intent += intent.text + "<br/>";
      } catch (e) {
        // return "";
      }

      try {
        let intent = JSON.parse(this.question.intent2);
        // return `${intent.text}`;
        compound_intent += intent.text + "<br/>";
      } catch (e) {
        // return "";
        compound_intent += "undefined" + "<br/>";
      }

      try {
        let intent = JSON.parse(this.question.intent3);
        compound_intent += intent.text + "<br/>";
      } catch (e) {
        compound_intent += "undefined" + "<br/>";
      }

      return compound_intent;
    },

    intent2() {
      try {
        let intent = JSON.parse(this.question.intent2);

        if (intent != null && intent != undefined && intent != "") {
          return `${intent.d1}->${intent.d2}->${intent.d3}`;
        } else {
          return "";
        }
      } catch (e) {
        return "";
      }
    },
    intent3() {
      try {
        let intent = JSON.parse(this.question.intent3);
        if (intent != null && intent != undefined && intent != "") {
          return `${intent.d1}->${intent.d2}->${intent.d3}`;
        } else {
          return "";
        }
      } catch (e) {
        return "";
      }
    },

    level() {
      let lvs = this.question.level.split(",");
      let lvl_options = this.$store.state.lvl_options;
      let chgs = "";
      for (let i = 0; i < lvs.length; i++) {
        chgs +=
          "<div class='lvlbox'>" +
          R.find(R.propEq("value", lvs[i]))(lvl_options)["text"] +
          "</div>";
      }

      return chgs;
    },
    videos() {
      return this.question.videos;
    },
  },
  mounted() {
    console.log(this.question);
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.qpanel {
  // border-top: 4px solid $color6;

  padding-bottom: 15px;
}
.divider {
  background: $point1;
  color: $gray50;
  padding: 4px 0 4px 0;
}
.below {
  border-bottom: 1px dashed $gray100;
  margin-top: 4px;
  margin-bottom: 4px;
  padding-bottom: 2px;
  padding-top: 2px;
}

.lvlwrapper ::v-deep div {
  background-color: $point1;
  padding: 4px 6px 4px 6px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.9em;
  margin-right: 4px;
  color: $gray100;
  display: inline;
}
</style>